angular.module('unica_social_stream.social_stream_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// SOCIAL STREAM
		.state('app.social_stream', {
			url: '/social-stream',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/social-stream/templates/social-stream.html',
					controller: 'SocialStreamBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// SOCIAL STREAM LIST
			.state('app.social_stream.list', {
				url: '/list/:event_id',
				views: {
					'socialStreamContent': {
						templateUrl: './modules/social-stream/templates/list.html',
						controller: 'SocialStreamListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Social Stream',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			});


});

